import { lazyLoad } from 'utils/loadable';

export const CannedReportsPage = lazyLoad(
  () => import('./index'),
  module => module.CannedReports,
);
